/**
 * Texto fijo junto a la estrella cuando **no hay calificación** (`ratingValue` omitido o vacío).
 * No es configurable por props.
 */
export const CATALOG_CARD_RATING_TEXT_NO_QUALIFICATION = '0.0' as const;

/**
 * Texto mostrado junto a la estrella: sin calificación → {@link CATALOG_CARD_RATING_TEXT_NO_QUALIFICATION};
 * con calificación → el valor recortado tal cual.
 */
export function getCatalogCardRatingDisplayText(trimmedRating: string): string {
  if (trimmedRating.length === 0) return CATALOG_CARD_RATING_TEXT_NO_QUALIFICATION;
  return trimmedRating;
}
